import React from 'react';

export type LicenseType =
  | 'standard'
  | 'pro'
  | 'business'
  | 'enterprise'
  | 'none';

export const licenseConfig: Record<
  LicenseType,
  { label: string; badgeClass: string; dotClass: string }
> = {
  standard: {
    label: 'Standard',
    badgeClass: 'tm-badge tm-badge-standard',
    dotClass: 'tm-badge-dot tm-dot-standard',
  },
  pro: {
    label: 'Pro',
    badgeClass: 'tm-badge tm-badge-pro',
    dotClass: 'tm-badge-dot tm-dot-pro',
  },
  business: {
    label: 'Business',
    badgeClass: 'tm-badge tm-badge-business',
    dotClass: 'tm-badge-dot tm-dot-business',
  },
  enterprise: {
    label: 'Enterprise',
    badgeClass: 'tm-badge tm-badge-enterprise',
    dotClass: 'tm-badge-dot tm-dot-enterprise',
  },
  none: {
    label: 'No License',
    badgeClass: 'tm-badge tm-badge-none',
    dotClass: 'tm-badge-dot tm-dot-none',
  },
};

interface LicenseBadgeProps {
  license: LicenseType;
}

const LicenseBadge: React.FC<LicenseBadgeProps> = ({ license }) => {
  const config = licenseConfig[license];
  return (
    <span className={config?.badgeClass}>
      <span className={config?.dotClass} />
      {config?.label}
    </span>
  );
};

export default LicenseBadge;
